// extracted by mini-css-extract-plugin
export default {"SingleTile":"SingleTile_SingleTile__ldWMu"};